export interface DirectDebitValidationRequest {
  request_source?: string;
  channel_code?: string;
  channel_group_code?: string;
  client_code?: string;
  client_group_code?: string;
  branchCode: string;
  accountNumber: string;
}

export interface DirectDebitValidationResponse {
  isValid: boolean;
}

export enum DirectDebitFormState {
  UNKNOWN = 'UNKNOWN',
  AUTOFILLVALID = 'AUTOFILLVALID',
  INVALID = 'INVALID',
  VALID = 'VALID',
  RETRIES_EXCEEDED = 'RETRIES_EXCEEDED',
  ERROR = 'ERROR',
}

export interface SortCode {
  sort1: string;
  sort2: string;
  sort3: string;
}
